export class ReportHeaderModel {
    salesPersonName: string;
    estimateName: string;
    jobStart: string;
    estimateId: string;
    jobEnd: string;
}